import {FormWrapperProps} from "@/constants/type/props";


export default function FormWrapper({
                                      title,
                                      description,
                                      onSubmit,
                                      isSubmitting,
                                      errorMessage,
                                      children,
                                    }: FormWrapperProps) {
  return (
    <>
      <div className="container-fluid -title-pane">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="-sectionTitle">
                {title}
              </div>
              <br/>
              {description}
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid -container-fix -passengerInfoContainer">
        <div className="container">
          <div className="row -passengerInfo">
            <div className="col-md-12">
              <form onSubmit={onSubmit}>
                {children}

                <div className="row d-flex justify-content-center pt-5">
                  <div className="col-md-4 text-center d-grid gap-2">
                    {errorMessage && (
                      <div className="alert alert-danger" role="alert">
                        {errorMessage}
                      </div>
                    )}
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn btn-primary btn-lg float-end -action"
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
    
  );
}
